import styled from "styled-components/macro";

export const StyledTabbedPageRoot = styled.div`
  display: flex;
  min-height: 100%;
  height: calc(100vh - var(--header-height));

  .title-normal {
    font-size: 1rem;
  }

  aside {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: var(--tabbed-sidebar-width);
    border-right: 1px solid var(--border-gray-light);
    background: var(--white);
  }

  .main {
    flex-grow: 1;
    padding: 1rem 1.5rem;
    width: calc(100vw - var(--sidebar-width) - var(--tabbed-sidebar-width));
    overflow: auto;

    .main-title {
      margin-bottom: 1rem;
    }
  }
`;

export const SidebarNavItem = styled.div<{ direction: "row" | "column" }>`
  display: flex;
  flex-direction: ${(props) => props.direction};
  align-items: ${(props) =>
    props.direction === "row" ? "center" : "flex-start"};
  color: var(--gray);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-bold);
  margin: 0.25rem 0;
  padding: 0.5rem 0.75rem;

  &.active {
    color: var(--primary-black);
    background: var(--background-gray);
  }

  &:hover {
    text-decoration: none;
    background: var(--background-green);
    color: var(--green);
  }
`;
